import script from "./MessagingPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessagingPopup.vue?vue&type=script&setup=true&lang=ts"

import "./MessagingPopup.vue?vue&type=style&index=0&id=003e71e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-003e71e3"]])

export default __exports__